// extracted by mini-css-extract-plugin
export default {"container":"styles_container__hzIQq","breadcrumbContainer":"styles_breadcrumbContainer__nVRKr","hidden":"styles_hidden__dkXEB","invisible":"styles_invisible__stKfb"};